//
// Copyright (c) 2024 Comcast
//

import PropTypes from 'prop-types'
import { Field } from 'react-final-form'

const ConditionalField = ({ displayCondition, children }) => {
  if (!displayCondition) {
    return children
  }

  return (
    <Field name={displayCondition.fieldName} subscription={{ value: true }}>
      {({ input: { value } }) => (value === displayCondition.fieldValue ? children : null)}
    </Field>
  )
}

ConditionalField.propTypes = {
  displayCondition: PropTypes.object,
  children: PropTypes.node,
}

export default ConditionalField
